export default __webpack_public_path__ + "static/WhatsApp-hero-1-884d9054ed7ed44cf55122d656c3cc34.webp";